import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';

import { LT_ROUTE } from 'bl/loggers.bl';
import LINK from 'constants/link.const';
import { COGNITO_STATE, selectCognitoState } from 'utils/cognito.util';
import { fromAnyToJsonClone } from 'utils/converters/json.util';
import logger from 'utils/logger.util';

const CTAG = 'PrivateRoute';
const L = logger([CTAG, LT_ROUTE]);

const PrivateRouteSpinner = () => (
  <div data-bem="PrivateRouteSpinner" className="loading-wrap">
    <div data-bem="PrivateRouteSpinner__anim" className="loading-anim">
      <div data-bem="PrivateRouteSpinner__title" className="loading-title">
        <span data-bem="PrivateRouteSpinner__text">Logging in</span>
      </div>
    </div>
    <div data-bem="PrivateRouteSpinner__feedback" className="loading-feedback">
      Checking passwords
    </div>
  </div>
);

const PrivateRoute = ({ component: Component, componentToLoad, cognitoState, ...props }) => {
  const info = { Component, componentToLoad, props };
  L.debug('()', 'cognitoState:', cognitoState, 'info:', info, 'cloned info:', fromAnyToJsonClone(info));

  if (cognitoState === COGNITO_STATE.loading) {
    return <Route {...props} render={PrivateRouteSpinner} />;
  }

  if (cognitoState === COGNITO_STATE.in) {
    return <Route {...props} render={(props) => <Component {...props} component={componentToLoad} />} />;
  }

  if (cognitoState === COGNITO_STATE.needConfirmation) {
    L.info('()', 'User is in state of', cognitoState, 'redirecting to', LINK.onboardingSms);
    return (
      <Route
        {...props}
        render={({ location }) => <Redirect to={{ pathname: LINK.onboardingSms, state: { from: location } }} />}
      />
    );
  }

  L.info('()', 'User is in state of', cognitoState, 'redirecting to', LINK.root);
  return (
    <Route {...props} render={({ location }) => <Redirect to={{ pathname: LINK.root, state: { from: location } }} />} />
  );
};

const PrivateRouteHoc = withRouter(
  connect((state) => ({
    cognitoState: selectCognitoState(state),
  }))(PrivateRoute),
);

export default PrivateRouteHoc;
